'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { Analytics } from './Analytics';
import { LandingNav } from './LandingNav';
import { Hero } from './Hero';
import { DemoVideoModal } from './DemoVideoModal';
const Features = dynamic(() => import('./Features').then(m => ({
  default: m.Features
})), {
  loading: () => <section className="min-h-[40vh]" aria-hidden />
});
const HowItWorks = dynamic(() => import('./HowItWorks').then(m => ({
  default: m.HowItWorks
})), {
  loading: () => <section className="min-h-[40vh]" aria-hidden />
});
const LandingFaq = dynamic(() => import('./LandingFaq').then(m => ({
  default: m.LandingFaq
})), {
  loading: () => <section className="min-h-[40vh]" aria-hidden />
});
const FinalCta = dynamic(() => import('./FinalCta').then(m => ({
  default: m.FinalCta
})), {
  loading: () => <section className="min-h-[40vh]" aria-hidden />
});
const Footer = dynamic(() => import('./Footer').then(m => ({
  default: m.Footer
})), {
  loading: () => <footer className="min-h-[20vh]" aria-hidden />
});
export function LandingPage() {
  const $ = _c(7);
  const [demoOpen, setDemoOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Analytics />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LandingNav onOpenDemo={() => setDemoOpen(true)} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== demoOpen) {
    t2 = <DemoVideoModal open={demoOpen} onOpenChange={setDemoOpen} />;
    $[2] = demoOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <main id="main-content" className="pb-20 md:pb-28"><Hero onWatchDemo={() => setDemoOpen(true)} /><Features /><HowItWorks /><LandingFaq /><FinalCta /><Footer /></main>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="landing dark min-h-screen bg-[var(--landing-bg)]">{t0}{t1}{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}